
export enum ProInUseCd {
	ELECTRONIC = 'Electronic',
	LABEL = 'Label',
	LEGACY = 'Legacy',
	NOT_USED = 'NotUsed',
	WEB = 'Web'}

